// === Баннер «Вышло обновление — обнови страницу» (п.112 force-update, веб) ===
//
// Проблема: юзер держит вкладку открытой днями, а мы деплоим новый бандл —
// старый SPA продолжает жить и может быть несовместим с сервером.
// Решение: при сборке в бандл вшивается src/version.json, рядом с бандлом лежит
// public/version.json. Раз в 5 минут (и при возврате на вкладку) сверяем builtAt —
// не совпало → показываем несмахиваемый баннер с кнопкой перезагрузки.

import { useEffect, useState } from 'react';
import bundleVersion from '../version.json';

const CHECK_INTERVAL_MS = 5 * 60 * 1000;   // 5 минут

const UpdatePrompt = () => {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    let stopped = false;

    const check = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (!res.ok) return;
        const fresh = await res.json();
        if (!stopped && fresh.builtAt && fresh.builtAt !== bundleVersion.builtAt) {
          setStale(true);
        }
      } catch {
        // сеть моргнула — проверим в следующий раз
      }
    };

    const timer = setInterval(check, CHECK_INTERVAL_MS);
    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      stopped = true;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  if (!stale) return null;

  return (
    <div style={{
      position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16,
      padding: '12px 20px',
      background: 'rgba(15, 25, 35, 0.97)',
      borderTop: '1px solid #E8B84B',
      color: '#F5F5F5',
      fontFamily: 'inherit', fontSize: 15,
    }}>
      <span>Вышло обновление BlotMe — обнови страницу, чтобы продолжить.</span>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '8px 20px', borderRadius: 10, border: 'none', cursor: 'pointer',
          background: '#E8B84B', color: '#131C26', fontWeight: 700, fontSize: 15,
        }}
      >
        Обновить
      </button>
    </div>
  );
};

export default UpdatePrompt;
